export default "__VITE_ASSET__CeVWthYq__"